import { BigNumberish, ethers } from 'ethers';

export default function parseUnits(value: string, decimals?: BigNumberish) {
  try {
    return ethers.utils.parseUnits(value, decimals);
  } catch (error) {
    return ethers.constants.Zero;
  }
}
